export const TICKET_TYPE = {
  PICKUP: 'PICKUP',
  DELIVERY: 'DELIVERY',
  EXPRESS: 'EXPRESS',
  CURBSIDE: 'CURBSIDE',
  DRIVE_THRU: 'DRIVE_THRU',
};



// WEBPACK FOOTER //
// ./src/const/ticket_type.js